import { updateNotification } from "../../../../service/Notification/NotificationService";
import { notifyError } from "../../../ToastContainer/Toast/Toast";

export const notificationMessage = (type: string, orderId: number) => {
  switch (type) {
    case "order":
      return `🛒 New Order Received! Order #${orderId}. Please process it promptly.`;
    case "invoice":
      return `🧾 Return Initiated for Order #${orderId}. Please review and take necessary action.`;
  }
}

export const updateNotificationFunction = async (id: any, payload: any) => {
  try {
    await updateNotification(id, payload);
  } catch (error) {
    notifyError("Something Went Wrong");
  }
}